// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1732":"5168e1b5","6340":"5168e1b5","9553":"58297519"}[chunkId] + ".chunk.css";
};